import React, { useContext, useState } from 'react'
import { 
  Container,
  HeaderDiv,
  HeaderText,
  HeaderTip,
  HeaderTipWithTitle,
  ViewMinMaxImg
} from './style'
import StructureTable from './StructureTable'
import FileInputStructure from './FileInput'
import CertificatesContext from '../../../../../contexts/CertificatesContext'
import view from '../../../../../assets/certificates/AddCertificate/view.svg'
import exclamation from '../../../../../assets/certificates/AddCertificate/exclamation.svg'
import check from '../../../../../assets/check.svg'

interface CertificateProps {
  index: number
}

const CertificateStructure: React.FC<CertificateProps> = (props) => {
  const { structureData } = useContext(CertificatesContext)
  const [ viewMinMax, setViewMinMax ] = useState<boolean>(false)
  const [ hasOutOfNorm, setHasOutOfNorm ] = useState<boolean>(false)

  return (
      <Container>
        <HeaderDiv>
          <HeaderTipWithTitle>
            <HeaderText>{structureData[props.index].name}</HeaderText>
            {hasOutOfNorm && structureData[props.index].minTable.length > 0 ?
            <HeaderTip className='out'>
              <img src={exclamation} alt='exclamation icon' draggable='false' />
              Existem parâmetros fora da norma
            </HeaderTip>
            : structureData[props.index].minTable.length > 0 && !hasOutOfNorm ?
            <HeaderTip className='in'>
              <img src={check} alt='check icon' draggable='false' />
              Parâmetros conforme a norma
            </HeaderTip>
            : null
            }
          </HeaderTipWithTitle>
          {structureData[props.index].maxTable.length > 0 && structureData[props.index].minTable.length > 0 &&
            <ViewMinMaxImg 
              src={view}
              alt='View icon' 
              onMouseEnter={() => setViewMinMax(true)}
              onMouseLeave={() => setViewMinMax(false)}
            /> 
          }
        </HeaderDiv>
        {structureData[props.index].hasTable && <StructureTable index={props.index} viewMinMax={viewMinMax} setHasOutOfNorm={setHasOutOfNorm} />}
        {structureData[props.index].fileImport && <FileInputStructure index={props.index}/>}
      </Container>
  )
}
export default CertificateStructure
